import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import VNavMenuItem from './VerticalNavMenuItem.vue'
import HNavMenuItem from './HorizontalNavMenuItem.vue';
export default {
  name: 'h-nav-menu-group',
  props: {
    openHover: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object
    },
    groupIndex: {
      type: Number
    },
    bottom: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HNavMenuItem: HNavMenuItem
  },
  data: function data() {
    return {
      openItems: false,
      hovered: false,
      dropLeft: false
    };
  },
  computed: {
    iconClasses: function iconClasses() {
      var classes = 'mr-3 ';
      classes += this.groupIndex % 1 != 0 ? 'w-3 h-3' : 'w-5 h-5';
      return classes;
    },
    styleItems: function styleItems() {
      var style = {};

      if (this.bottom) {
        style.top = '100%';
        style.left = '0';
      } else {
        style.top = '12px';
        style.left = '100%';
      }

      if (this.dropLeft) {
        style.left = null;
        style.right = '100%';
      }

      if (this.$vs.rtl) {
        var temp = style.left;
        style.left = style.right;
        style.right = temp;
      }

      return style;
    },
    itemIcon: function itemIcon() {
      // return (index) => {
      //   // if (!((index.match(/\./g) || []).length > 1)) return "CircleIcon"
      // }
      return 'CircleIcon';
    },
    isGroupActive: function isGroupActive() {
      var _this = this;

      return function (item) {
        var path = _this.$route.fullPath;
        var open = false;
        var routeParent = _this.$route.meta ? _this.$route.meta.parent : undefined;

        var func = function func(item) {
          if (item.submenu) {
            item.submenu.forEach(function (item) {
              if ((path == item.url || routeParent == item.slug) && item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };

        func(item);
        return open;
      };
    }
  },
  watch: {
    hovered: function hovered(val) {
      var _this2 = this;

      this.$nextTick(function () {
        if (val) {
          var dd = _this2.$refs.childDropdown;

          if (window.innerHeight - dd.getBoundingClientRect().top - dd.getBoundingClientRect().height - 28 < 1) {
            var maxHeight = window.innerHeight - dd.getBoundingClientRect().top - 70;
            dd.style.maxHeight = "".concat(maxHeight, "px");
            dd.style.overflowY = 'auto';
            dd.style.overflowX = 'hidden';
          }

          if (dd.getBoundingClientRect().left + dd.offsetWidth - (window.innerWidth - 16) >= 0 || _this2.$parent.dropLeft) {
            _this2.dropLeft = true;
          }

          if (_this2.$vs.rtl) {
            if (dd.getBoundingClientRect().right - dd.offsetWidth - 16 < 0) {
              _this2.dropLeft = true;
            }
          }
        } else {
          _this2.dropLeft = false;
        }
      });
    }
  },
  methods: {
    mouseover: function mouseover() {
      this.hovered = true;

      if (this.openHover) {
        this.showChildren();
      }
    },
    mouseout: function mouseout() {
      this.hovered = false;

      if (this.openHover) {
        this.showChildren(false);
      }
    },
    showChildren: function showChildren() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.openItems = val;
    }
  }
};